export default __webpack_public_path__ + "static/media/pub.6396016f.jpg";